import mapboxgl from 'mapbox-gl';

// Active jobs, permits, customer cases, sensor events, crew locations
const markersData: GeoJSON.FeatureCollection = {
  type: 'FeatureCollection',
  features: [
    // ═══════════════════════════════════════════════════════════════
    // Active Jobs - Green (12 total)
    // ═══════════════════════════════════════════════════════════════
    {
      type: 'Feature',
      properties: { id: 'job-001', type: 'active-job', label: 'Mains Repair - Deansgate', panel: 'job-detail', priority: 'P2', modelId: 'work-barrier' },
      geometry: { type: 'Point', coordinates: [-2.2488, 53.4793] },
    },
    {
      type: 'Feature',
      properties: { id: 'job-002', type: 'active-job', label: 'Service Connection - Oxford Road', panel: 'job-detail', priority: 'P3', modelId: 'work-barrier' },
      geometry: { type: 'Point', coordinates: [-2.2366, 53.4774] },
    },
    {
      type: 'Feature',
      properties: { id: 'job-003', type: 'active-job', label: 'Valve Replacement - Piccadilly', panel: 'job-detail', priority: 'P2', modelId: 'work-barrier' },
      geometry: { type: 'Point', coordinates: [-2.2310, 53.4808] },
    },
    {
      type: 'Feature',
      properties: { id: 'job-004', type: 'active-job', label: 'Hydrant Inspection - Ancoats', panel: 'job-detail', priority: 'P4', modelId: 'work-barrier' },
      geometry: { type: 'Point', coordinates: [-2.2280, 53.4845] },
    },
    {
      type: 'Feature',
      properties: { id: 'job-005', type: 'active-job', label: 'Gas Main Renewal - Great Ancoats St', panel: 'job-detail', priority: 'P1', modelId: 'work-barrier' },
      geometry: { type: 'Point', coordinates: [-2.2350, 53.4835] },
    },
    {
      type: 'Feature',
      properties: { id: 'job-006', type: 'active-job', label: 'Cable Jointing - Northern Quarter', panel: 'job-detail', priority: 'P3', modelId: 'work-barrier' },
      geometry: { type: 'Point', coordinates: [-2.2330, 53.4825] },
    },
    {
      type: 'Feature',
      properties: { id: 'job-007', type: 'active-job', label: 'Leak Repair - Portland St', panel: 'job-detail', priority: 'P2', modelId: 'work-barrier' },
      geometry: { type: 'Point', coordinates: [-2.2380, 53.4790] },
    },
    {
      type: 'Feature',
      properties: { id: 'job-008', type: 'active-job', label: 'Pipe Relining - Whitworth St', panel: 'job-detail', priority: 'P3', modelId: 'work-barrier' },
      geometry: { type: 'Point', coordinates: [-2.2420, 53.4760] },
    },
    {
      type: 'Feature',
      properties: { id: 'job-009', type: 'active-job', label: 'Meter Installation - Quay St', panel: 'job-detail', priority: 'P4', modelId: 'work-barrier' },
      geometry: { type: 'Point', coordinates: [-2.2520, 53.4770] },
    },
    {
      type: 'Feature',
      properties: { id: 'job-010', type: 'active-job', label: 'Stop Tap Renewal - Bridge St', panel: 'job-detail', priority: 'P2', modelId: 'work-barrier' },
      geometry: { type: 'Point', coordinates: [-2.2480, 53.4820] },
    },
    {
      type: 'Feature',
      properties: { id: 'job-011', type: 'active-job', label: 'Boundary Box - Lever St', panel: 'job-detail', priority: 'P3', modelId: 'work-barrier' },
      geometry: { type: 'Point', coordinates: [-2.2340, 53.4850] },
    },
    {
      type: 'Feature',
      properties: { id: 'job-012', type: 'active-job', label: 'Ferrule Insert - Oldham St', panel: 'job-detail', priority: 'P4', modelId: 'work-barrier' },
      geometry: { type: 'Point', coordinates: [-2.2360, 53.4840] },
    },

    // ═══════════════════════════════════════════════════════════════
    // At-risk Permits - Amber (8 total)
    // ═══════════════════════════════════════════════════════════════
    {
      type: 'Feature',
      properties: { id: 'permit-001', type: 'permit-risk', label: 'Permit at risk - Mancunian Way', panel: 'permit-risk', status: 'approaching', modelId: 'traffic-cone' },
      geometry: { type: 'Point', coordinates: [-2.2400, 53.4720] },
    },
    {
      type: 'Feature',
      properties: { id: 'permit-002', type: 'permit-risk', label: 'Permit breached - A56 Bridgewater', panel: 'permit-risk', status: 'breached', modelId: 'traffic-cone' },
      geometry: { type: 'Point', coordinates: [-2.2550, 53.4730] },
    },
    {
      type: 'Feature',
      properties: { id: 'permit-003', type: 'permit-risk', label: 'Evidence weak - Chester Road', panel: 'permit-risk', status: 'evidence-weak', modelId: 'traffic-cone' },
      geometry: { type: 'Point', coordinates: [-2.2530, 53.4750] },
    },
    {
      type: 'Feature',
      properties: { id: 'permit-004', type: 'permit-risk', label: 'SLA approaching - Oldham Road', panel: 'permit-risk', status: 'approaching', modelId: 'traffic-cone' },
      geometry: { type: 'Point', coordinates: [-2.2250, 53.4870] },
    },
    {
      type: 'Feature',
      properties: { id: 'permit-005', type: 'permit-risk', label: 'Permit breached - Rochdale Rd', panel: 'permit-risk', status: 'breached', modelId: 'traffic-cone' },
      geometry: { type: 'Point', coordinates: [-2.2300, 53.4880] },
    },
    {
      type: 'Feature',
      properties: { id: 'permit-006', type: 'permit-risk', label: 'Duration overrun - Stockport Rd', panel: 'permit-risk', status: 'approaching', modelId: 'traffic-cone' },
      geometry: { type: 'Point', coordinates: [-2.2350, 53.4730] },
    },
    {
      type: 'Feature',
      properties: { id: 'permit-007', type: 'permit-risk', label: 'Reinstatement overdue - Cross St', panel: 'permit-risk', status: 'breached', modelId: 'traffic-cone' },
      geometry: { type: 'Point', coordinates: [-2.2460, 53.4810] },
    },
    {
      type: 'Feature',
      properties: { id: 'permit-008', type: 'permit-risk', label: 'Evidence missing - King St', panel: 'permit-risk', status: 'evidence-weak', modelId: 'traffic-cone' },
      geometry: { type: 'Point', coordinates: [-2.2440, 53.4790] },
    },

    // ═══════════════════════════════════════════════════════════════
    // Customer Cases - Blue (8 total)
    // ═══════════════════════════════════════════════════════════════
    {
      type: 'Feature',
      properties: { id: 'cust-001', type: 'customer-case', label: 'Mrs. Chen - Low pressure', panel: 'customer-journey', vulnerable: false, modelId: 'house' },
      geometry: { type: 'Point', coordinates: [-2.2280, 53.4780] },
    },
    {
      type: 'Feature',
      properties: { id: 'cust-002', type: 'customer-case', label: 'Mr. Khan - No supply (vulnerable)', panel: 'customer-journey', vulnerable: true, modelId: 'house' },
      geometry: { type: 'Point', coordinates: [-2.2520, 53.4810] },
    },
    {
      type: 'Feature',
      properties: { id: 'cust-003', type: 'customer-case', label: 'Ms. Wright - Discoloured water', panel: 'customer-journey', vulnerable: false, modelId: 'house' },
      geometry: { type: 'Point', coordinates: [-2.2450, 53.4750] },
    },
    {
      type: 'Feature',
      properties: { id: 'cust-004', type: 'customer-case', label: 'Mr. Patel - Meter dispute', panel: 'customer-journey', vulnerable: true, modelId: 'house' },
      geometry: { type: 'Point', coordinates: [-2.2380, 53.4830] },
    },
    {
      type: 'Feature',
      properties: { id: 'cust-005', type: 'customer-case', label: 'Mrs. Thompson - Leak on supply', panel: 'customer-journey', vulnerable: false, modelId: 'house' },
      geometry: { type: 'Point', coordinates: [-2.2560, 53.4780] },
    },
    {
      type: 'Feature',
      properties: { id: 'cust-006', type: 'customer-case', label: 'Mr. Davies - Sewer flooding', panel: 'customer-journey', vulnerable: true, modelId: 'house' },
      geometry: { type: 'Point', coordinates: [-2.2300, 53.4760] },
    },
    {
      type: 'Feature',
      properties: { id: 'cust-007', type: 'customer-case', label: 'Ms. Ali - Billing query', panel: 'customer-journey', vulnerable: false, modelId: 'house' },
      geometry: { type: 'Point', coordinates: [-2.2470, 53.4840] },
    },
    {
      type: 'Feature',
      properties: { id: 'cust-008', type: 'customer-case', label: 'Mr. O\'Brien - Blocked drain', panel: 'customer-journey', vulnerable: false, modelId: 'house' },
      geometry: { type: 'Point', coordinates: [-2.2410, 53.4870] },
    },

    // ═══════════════════════════════════════════════════════════════
    // Sensor Events - Red (5 total - critical infrastructure alerts)
    // ═══════════════════════════════════════════════════════════════
    {
      type: 'Feature',
      properties: { id: 'sensor-001', type: 'sensor-event', label: 'BURST MAIN - Whitworth St', panel: 'ai-control-room', severity: 'critical', modelId: 'sensor-box' },
      geometry: { type: 'Point', coordinates: [-2.2380, 53.4760] },
    },
    {
      type: 'Feature',
      properties: { id: 'sensor-002', type: 'sensor-event', label: 'Pressure drop - Princess St', panel: 'ai-control-room', severity: 'high', modelId: 'sensor-box' },
      geometry: { type: 'Point', coordinates: [-2.2400, 53.4780] },
    },
    {
      type: 'Feature',
      properties: { id: 'sensor-003', type: 'sensor-event', label: 'Sewer level rising - Medlock', panel: 'wastewater-workbank', severity: 'high', modelId: 'sensor-box' },
      geometry: { type: 'Point', coordinates: [-2.2300, 53.4740] },
    },
    {
      type: 'Feature',
      properties: { id: 'sensor-004', type: 'sensor-event', label: 'GAS LEAK DETECTED - Canal St', panel: 'ai-control-room', severity: 'critical', modelId: 'sensor-box' },
      geometry: { type: 'Point', coordinates: [-2.2340, 53.4800] },
    },
    {
      type: 'Feature',
      properties: { id: 'sensor-005', type: 'sensor-event', label: 'Flow anomaly - Irwell interceptor', panel: 'ai-control-room', severity: 'high', modelId: 'sensor-box' },
      geometry: { type: 'Point', coordinates: [-2.2540, 53.4830] },
    },

    // ═══════════════════════════════════════════════════════════════
    // Crew Locations - White (4 total)
    // ═══════════════════════════════════════════════════════════════
    {
      type: 'Feature',
      properties: { id: 'crew-001', type: 'crew-location', label: 'Crew Alpha - 4 operatives', panel: 'dispatch-screen', status: 'on-site' },
      geometry: { type: 'Point', coordinates: [-2.2370, 53.4770] },
    },
    {
      type: 'Feature',
      properties: { id: 'crew-002', type: 'crew-location', label: 'Crew Bravo - 3 operatives', panel: 'dispatch-screen', status: 'en-route' },
      geometry: { type: 'Point', coordinates: [-2.2500, 53.4790] },
    },
    {
      type: 'Feature',
      properties: { id: 'crew-003', type: 'crew-location', label: 'Crew Charlie - 2 operatives', panel: 'dispatch-screen', status: 'on-site' },
      geometry: { type: 'Point', coordinates: [-2.2280, 53.4850] },
    },
    {
      type: 'Feature',
      properties: { id: 'crew-004', type: 'crew-location', label: 'Crew Delta - 5 operatives', panel: 'dispatch-screen', status: 'on-site' },
      geometry: { type: 'Point', coordinates: [-2.2450, 53.4740] },
    },
  ],
};

export function addMarkerLayers(
  map: mapboxgl.Map,
  setPanel: (panel: string) => void
) {
  // Models now rendered by Three.js layer — markers use circle/symbol layers only

  map.addSource('markers', {
    type: 'geojson',
    data: markersData,
  });

  // Pulsing animation rings beneath markers - FLAT on the map surface
  map.addSource('markers-pulse', {
    type: 'geojson',
    data: markersData,
  });

  map.addLayer({
    id: 'markers-pulse-ring',
    type: 'circle',
    source: 'markers-pulse',
    paint: {
      'circle-radius': 6,
      'circle-color': 'transparent',
      'circle-stroke-color': [
        'match',
        ['get', 'type'],
        'active-job',
        '#10b981',
        'permit-risk',
        '#f59e0b',
        'customer-case',
        '#3b82f6',
        'sensor-event',
        '#ef4444',
        'crew-location',
        '#ffffff',
        '#ffffff',
      ],
      'circle-stroke-width': 3,
      'circle-opacity': 0.9,
      'circle-pitch-alignment': 'map',
      'circle-pitch-scale': 'map',
    },
  } as any);

  // Ground-level glow layer - flat on the map
  map.addLayer({
    id: 'markers-ground-glow',
    type: 'circle',
    source: 'markers',
    paint: {
      'circle-radius': ['match', ['get', 'type'],
        'sensor-event', 20,
        'permit-risk', 16,
        'active-job', 14,
        'customer-case', 13,
        'crew-location', 12,
        14,
      ],
      'circle-color': [
        'match',
        ['get', 'type'],
        'active-job',
        '#10b981',
        'permit-risk',
        '#f59e0b',
        'customer-case',
        '#3b82f6',
        'sensor-event',
        '#ef4444',
        'crew-location',
        '#ffffff',
        '#ffffff',
      ],
      'circle-opacity': 0.2,
      'circle-blur': 1,
      'circle-pitch-alignment': 'map',
      'circle-pitch-scale': 'map',
    },
  } as any);

  // Marker dots (replaces old 3D model layer)
  map.addLayer({
    id: 'markers-3d',
    type: 'circle',
    source: 'markers',
    filter: ['has', 'modelId'],
    paint: {
      'circle-radius': ['interpolate', ['linear'], ['zoom'], 12, 4, 16, 8],
      'circle-color': ['match', ['get', 'type'],
        'sensor-event', '#ef4444',
        'active-job', '#10b981',
        'permit-risk', '#f59e0b',
        'customer-case', '#60a5fa',
        '#94a3b8',
      ],
      'circle-opacity': 0.85,
      'circle-stroke-width': 1.5,
      'circle-stroke-color': '#ffffff',
      'circle-stroke-opacity': 0.4,
    },
  });

  // Crew Locations - White circles (no 3D model, keep as dots)
  map.addLayer({
    id: 'markers-crews',
    type: 'circle',
    source: 'markers',
    filter: ['==', ['get', 'type'], 'crew-location'],
    paint: {
      'circle-radius': ['interpolate', ['linear'], ['zoom'], 12, 4, 16, 7],
      'circle-color': '#ffffff',
      'circle-opacity': 0.9,
      'circle-stroke-width': 2,
      'circle-stroke-color': '#64748b',
    },
  });

  // Popup on hover
  const popup = new mapboxgl.Popup({
    closeButton: false,
    closeOnClick: false,
    className: 'nv-popup',
    offset: 15,
  });

  const interactiveLayers = [
    'markers-3d',
    'markers-crews',
  ];

  interactiveLayers.forEach((layerId) => {
    map.on('mouseenter', layerId, (e) => {
      map.getCanvas().style.cursor = 'pointer';
      const feature = e.features?.[0];
      if (!feature || !feature.properties) return;

      const coords = (feature.geometry as GeoJSON.Point).coordinates.slice() as [
        number,
        number,
      ];
      const label = feature.properties.label || 'Unknown';
      const type = feature.properties.type || '';

      popup
        .setLngLat(coords)
        .setHTML(
          `<div class="nv-popup-content">
            <span class="nv-popup-type">${type.replace(/-/g, ' ')}</span>
            <span class="nv-popup-label">${label}</span>
          </div>`
        )
        .addTo(map);
    });

    map.on('mouseleave', layerId, () => {
      map.getCanvas().style.cursor = '';
      popup.remove();
    });

    map.on('click', layerId, (e) => {
      const feature = e.features?.[0];
      if (!feature || !feature.properties) return;
      const panelId = feature.properties.panel;
      if (panelId) {
        setPanel(panelId);
      }
    });
  });

  // Hide all marker layers by default - only shown during scenarios
  ['markers-3d', 'markers-ground-glow', 'markers-pulse-ring', 'markers-labels', 'markers-crews'].forEach(id => {
    if (map.getLayer(id)) map.setLayoutProperty(id, 'visibility', 'none');
  });

  // Pulse animation loop - subtle ground-level radar sweep
  let pulsePhase = 0;
  function animatePulse() {
    pulsePhase = (pulsePhase + 0.008) % 1;
    const radius = 6 + pulsePhase * 12;
    const opacity = 0.3 - pulsePhase * 0.3;

    if (map.getLayer('markers-pulse-ring')) {
      map.setPaintProperty('markers-pulse-ring', 'circle-radius', radius);
      map.setPaintProperty('markers-pulse-ring', 'circle-opacity', opacity);
    }

    requestAnimationFrame(animatePulse);
  }

  animatePulse();
}
